import { content } from "./content";
import { createElement } from "react";
import Typewriter from "typewriter-effect";
import person from "../assets/image.jpg";
import { styles } from "./styles";

const Hero = () => {
  const { hero } = content;

  return (
    <section
      id="home"
      className="relative w-full min-h-screen flex items-center justify-center px-6"
    >
      {/* Background stays global (stars etc.) */}
      <div className="absolute inset-0 pointer-events-none" />

      {/* HERO CARD */}
      <div
        className="
          relative z-10 w-full max-w-7xl
          rounded-3xl
          bg-violet-500/1
          
          border border-violet-400/30
          shadow-[0_0_60px_rgba(145,94,255,0.25)]
          px-8 py-16 md:px-14 md:py-20
        "
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-14 items-center">

          {/* LEFT */}
          <div className="flex gap-6">
            {/* Accent */}
            <div className="flex flex-col items-center pt-2">
              <div className="w-4 h-4 rounded-full bg-[#915EFF]" />
              <div className="w-1 h-48 violet-gradient" />
            </div>

            {/* Text */}
            <div className="max-w-xl">
              <h1 className={`${styles.heroHeadText} text-white font-Merriweather`}>
                Hi, I’m{" "}
                <span className="text-[#915EFF]">Santhosh Raminedi</span>
              </h1>

              <h2 className="mt-4 text-xl sm:text-2xl text-gray-200 font-semibold">
                <Typewriter
                  options={{
                    strings: hero.btnArray,
                    autoStart: true,
                    loop: true,
                    delay: 60,
                    deleteSpeed: 40,
                  }}
                />
              </h2>

              <p className="mt-6 text-gray-300 leading-relaxed">
                I build scalable backend systems and intelligent AI agents that
                solve real-world problems — from cloud-native microservices to
                production-ready Generative AI workflows.
              </p>

              {/* Socials */}
              <div className="flex gap-4 mt-8">
                {hero.hero_content.map((item, i) => (
                  <a
                    key={i}
                    href={item.link}
                    target="_blank"
                    rel="noreferrer"
                    className="
                      w-11 h-11 rounded-full flex items-center justify-center
                      bg-violet-500/10
                      border border-violet-400/30
                      text-white text-xl
                      hover:bg-[#915EFF]
                      hover:scale-110
                      transition-all duration-300
                    "
                  >
                    {createElement(item.icon)}
                  </a>
                ))}
              </div>

              {/* CTAs */}
              <div className="flex gap-4 mt-10 flex-wrap">
                <a
                  href="#projects"
                  className="
                    px-7 py-3 rounded-xl
                    bg-[#915EFF] text-white font-semibold
                    hover:bg-violet-600 transition
                  "
                >
                  View Projects
                </a>

                <a
                  href="#contact"
                  className="
                    px-7 py-3 rounded-xl
                    border border-violet-400
                    text-violet-300
                    hover:bg-violet-400 hover:text-black
                    transition
                  "
                >
                  Contact Me
                </a>
              </div>
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="flex justify-center md:justify-end">
            <img
              src={person}
              alt="Santhosh"
              className="
                w-72 sm:w-80 rounded-full
                border-4 border-violet-500
                shadow-[0_0_50px_rgba(145,94,255,0.45)]
                hover:scale-105
                transition-transform duration-500
              "
            />
          </div>

        </div>
      </div>
    </section>
  );
};

export default Hero;
